import queryString from "query-string";

import ErrorMessage from "./ErrorMessage";

import { useFilters } from "../utils/use-filters";
import { useInfinitePosts } from "./use-infinite-posts";
import { useNormalizer } from "./use-normalizer";
import { usePosts } from "./use-posts";
import { useUrlParams } from "./use-url-params";
import { useUrlParamState } from "./use-url-param-state";

export {
	ErrorMessage,
	useFilters,
	useInfinitePosts,
	useNormalizer,
	usePosts,
	useUrlParams,
	useUrlParamState,
};

export const WpTermToSelectOption = ({ id, name }) => ({
	value: id,
	label: name,
});

export const WpTermToLabels = (labels, term) => {
	const { id, name } = term;
	labels[id] = name;
	return labels;
};

export const isArray = (value) => value instanceof Array;

export const objectToUrlParams = (obj) =>
	queryString.stringify(obj, { arrayFormat: "bracket" });
